import currency from 'currency.js';
import {
  REPORT_COLUMNS_TO_TABLE_COLUMNS,
  TABLE_COLUMNS_TO_REPORT_COLUMNS,
} from './OrderListView.constants';
import {
  OrderReportColumnLiterals,
  OrderTableColumnLiterals,
  OrderTableFields,
} from './OrderListView.types';
import { OrderList } from '@api';
import { VisibilityState } from '@trukt/ui/columns-settings-card';

export const fromOrderListResponseToJobTableRows = (data: OrderList) => {
  const jobRows = data.map((order) => {
    const jobRowDataItem: { guid: string } & OrderTableFields = {
      rawData: order,
      actualRevenue: currency(order.pricing ?? '').format(),
      client: order?.clientName ?? '',
      commodity: order.vehicleName ?? '',
      condition: order?.operable,
      contactName: order?.clientContactName ?? '',
      dateCreated: order.dateCreated ?? '',
      dateUpdated: order?.dateCreated ?? '',
      deliveryAddress: order.destinationAddress ?? '',
      deliveryCompletedDate: order?.dateCompleted ?? '',
      deliveryTerminal: order.destinationName ?? '',
      guid: order.guid,
      lotNumber: order?.lotNumber ?? '',
      number: order.number ?? '',
      pickupAddress: order.originAddress ?? '',
      pickupCompletedDate: order?.dateStarted ?? '',
      pickupTerminal: order.originName ?? '',
      poNumber: order.referenceNumber ?? '',
      requestedDeliveryDate: {
        start: order?.dateRequestedDeliveryStart ?? '',
        end: order?.dateRequestedDeliveryEnd ?? undefined,
        type: '',
      },
      requestedPickupDate: {
        start: order?.dateRequestedPickupStart ?? '',
        end: order?.dateRequestedPickupEnd ?? undefined,
        type: '',
      },
      scheduledDeliveryDate: {
        start: order?.dateScheduledDeliveryStart ?? '',
        end: order?.dateScheduledDeliveryEnd ?? undefined,
        type: '',
      },
      scheduledPickupDate: {
        start: order?.dateScheduledPickupStart ?? '',
        end: order?.dateScheduledPickupEnd ?? undefined,
        type: '',
      },
      shipperNote: '',
      status: order?.status ?? '',
      vin: order.commodityIdentifier ?? '',
    };
    return jobRowDataItem;
  });

  return jobRows;
};

export const getTableColumnsFromReportColumns = (
  reportColumns: OrderReportColumnLiterals[] = [],
): OrderTableColumnLiterals[] => {
  const tableColumns: OrderTableColumnLiterals[] = [];
  reportColumns.forEach((reportColumn) => {
    const tableColumn = REPORT_COLUMNS_TO_TABLE_COLUMNS[reportColumn];
    if (!tableColumn) return;
    tableColumns.push(tableColumn);
  });

  return tableColumns;
};

export const getReportColumnVisibility = (
  columns: (string | undefined)[],
  currentVisibility: VisibilityState,
): VisibilityState => {
  return columns.reduce<VisibilityState>((visibility, column) => {
    if (column === undefined) return visibility;

    visibility[column] = currentVisibility[column] ?? true;
    return visibility;
  }, {});
};

export const getReportColumnsFromTableColumns = (
  columns: OrderTableColumnLiterals[] = [],
): OrderReportColumnLiterals[] => {
  return columns.reduce<OrderReportColumnLiterals[]>(
    (accum, tableColumn) => {
      const id = tableColumn as OrderTableColumnLiterals;
      const reporColumns = TABLE_COLUMNS_TO_REPORT_COLUMNS[id];
      if (reporColumns) {
        accum.push(...reporColumns);
      }
      return accum;
    },
    ['shipperNotes', 'orderInstructions'],
  );
};
